type GetAcceptFormatsOptionValue = 'file' | 'image' | 'video' | 'all'

export const getAcceptFormats = (optionValue: GetAcceptFormatsOptionValue): string => {
  const files = '.doc,.docx,.xlsx,.xls,.pdf,.xps,.vsd,.vsdx,.rar,.zip'
  const image = '.png,.jpeg,.jpg,.bmp'
  const video = '.avi,.wmv,.mov,.mp4'
  const all_formats = [files, image, video].join(',')

  switch (optionValue) {
    case 'file':
      return files
    case 'image':
      return image
    case 'video':
      return video
    case 'all':
      return all_formats
    default:
      return ''
  }
}
